import { mainApiAxios as axios } from '@/plugins/axios'

export default {

    listNotes(taskId) {
        return axios.get(`notes?activityInstanceId=${taskId}`)
    },

    // every comment of the process the task belongs to, not just this task's
    listProcessComments(taskId) {
        return axios.get(`notes/by-task/${taskId}`)
    },

    updateNote(noteId, noteObj) {
        return axios.post(`notes/update/${noteId}`, noteObj)
    },

    addNote(noteObj) {
        return axios.post('notes', noteObj)
    },

    deleteNote(noteId) {
        return axios.post(`notes/delete/${noteId}`)
    }
}